"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLocalStorage = void 0;

var React = __importStar(require("react"));

var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

exports.useLocalStorage = function (key, initialValue, serializers) {
  if (!utils_1.isBrowser) {
    return [initialValue, utils_1.noop, utils_1.noop];
  }

  var _a = React.useState(function () {
    try {
      var value = initialValue;
      var localStorageValue = localStorage.getItem(key);

      if (localStorageValue !== null) {
        value = !!serializers ? serializers.read(JSON.parse(localStorageValue)) : JSON.parse(localStorageValue);
      } else {
        localStorage.setItem(key, JSON.stringify(!!serializers ? serializers.write(initialValue) : initialValue));
      }

      return value;
    } catch (_a) {
      console.warn('[LocalStorage]::getItem|setItem has thrown an error');
      return initialValue;
    }
  }),
      state = _a[0],
      setState = _a[1];

  var set = React.useCallback(function (valueOrFn) {
    try {
      var nstate = typeof valueOrFn === 'function' ? valueOrFn(state) : valueOrFn;

      if (!!nstate) {
        localStorage.setItem(key, JSON.stringify(!!serializers ? serializers.write(nstate) : nstate));
        setState(nstate);
      }
    } catch (_a) {
      console.warn('[LocalStorage]::setItem has thrown an error');
    }
  }, [key, state]);
  var remove = React.useCallback(function () {
    try {
      localStorage.removeItem(key);
      setState(undefined);
    } catch (_a) {
      console.warn('[LocalStorage]::removeItem has thrown an error');
    }
  }, [key, state]);
  return [state, set, remove];
};